import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY_OCCUPANCY_LIST_BY_COMMUNITY_API } from "./apiRoutes";

interface UseGetOccupancyListByCommunityProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyOccupancyListByCommunity = async (communityId: string) =>
  await axiosAuth.get(
    `${PROPERTY_OCCUPANCY_LIST_BY_COMMUNITY_API(communityId)}`
  );

const useGetPropertyOccupancyListByCommunity = ({
  communityId,
  queryParams,
}: UseGetOccupancyListByCommunityProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["communityOccupancyList", communityId],
    queryFn: () => getPropertyOccupancyListByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyOccupancyListByCommunity;
